/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/_onboarding'
import { Route as MainRouteImport } from './routes/_main'
import { Route as DocsRouteImport } from './routes/_docs'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as MainIndexRouteImport } from './routes/_main/index'
import { Route as OnboardingConnectAccountRouteImport } from './routes/_onboarding/connect-account'
import { Route as MainUploadProductsRouteImport } from './routes/_main/upload-products'
import { Route as MainAboutRouteImport } from './routes/_main/about'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as MainWhatsappMonitoringIndexRouteImport } from './routes/_main/whatsapp-monitoring.index'
import { Route as MainSettingsIndexRouteImport } from './routes/_main/settings/index'
import { Route as MainProductsIndexRouteImport } from './routes/_main/products/index'
import { Route as MainOrdersIndexRouteImport } from './routes/_main/orders/index'
import { Route as MainWhatsappMonitoringGroupIdRouteImport } from './routes/_main/whatsapp-monitoring.$groupId'
import { Route as MainOrdersUploadRouteImport } from './routes/_main/orders/upload'
import { Route as MainOrdersOrderIdRouteImport } from './routes/_main/orders/$orderId'
import { Route as DocsDocsTosRouteImport } from './routes/_docs/docs.tos'
import { Route as DocsDocsPrivacyPolicyRouteImport } from './routes/_docs/docs.privacy-policy'
import { Route as MainProductsAllocationIndexRouteImport } from './routes/_main/products/allocation/index'
import { Route as MainProductsAllocationUploadRouteImport } from './routes/_main/products/allocation/upload'
import { Route as MainOrdersUploadSummaryRequestIdRouteImport } from './routes/_main/orders/upload-summary.$requestId'
import { Route as MainOrdersGenerateInvoiceOrderIdRouteImport } from './routes/_main/orders/generate-invoice.$orderId'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/_onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const MainRoute = MainRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/_docs',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const MainIndexRoute = MainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainRoute,
} as any)
const OnboardingConnectAccountRoute =
  OnboardingConnectAccountRouteImport.update({
    id: '/connect-account',
    path: '/connect-account',
    getParentRoute: () => OnboardingRoute,
  } as any)
const MainUploadProductsRoute = MainUploadProductsRouteImport.update({
  id: '/upload-products',
  path: '/upload-products',
  getParentRoute: () => MainRoute,
} as any)
const MainAboutRoute = MainAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => MainRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const MainWhatsappMonitoringIndexRoute =
  MainWhatsappMonitoringIndexRouteImport.update({
    id: '/whatsapp-monitoring/',
    path: '/whatsapp-monitoring/',
    getParentRoute: () => MainRoute,
  } as any)
const MainSettingsIndexRoute = MainSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => MainRoute,
} as any)
const MainProductsIndexRoute = MainProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => MainRoute,
} as any)
const MainOrdersIndexRoute = MainOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => MainRoute,
} as any)
const MainWhatsappMonitoringGroupIdRoute =
  MainWhatsappMonitoringGroupIdRouteImport.update({
    id: '/whatsapp-monitoring/$groupId',
    path: '/whatsapp-monitoring/$groupId',
    getParentRoute: () => MainRoute,
  } as any)
const MainOrdersUploadRoute = MainOrdersUploadRouteImport.update({
  id: '/orders/upload',
  path: '/orders/upload',
  getParentRoute: () => MainRoute,
} as any)
const MainOrdersOrderIdRoute = MainOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => MainRoute,
} as any)
const DocsDocsTosRoute = DocsDocsTosRouteImport.update({
  id: '/docs/tos',
  path: '/docs/tos',
  getParentRoute: () => DocsRoute,
} as any)
const DocsDocsPrivacyPolicyRoute = DocsDocsPrivacyPolicyRouteImport.update({
  id: '/docs/privacy-policy',
  path: '/docs/privacy-policy',
  getParentRoute: () => DocsRoute,
} as any)
const MainProductsAllocationIndexRoute =
  MainProductsAllocationIndexRouteImport.update({
    id: '/products/allocation/',
    path: '/products/allocation/',
    getParentRoute: () => MainRoute,
  } as any)
const MainProductsAllocationUploadRoute =
  MainProductsAllocationUploadRouteImport.update({
    id: '/products/allocation/upload',
    path: '/products/allocation/upload',
    getParentRoute: () => MainRoute,
  } as any)
const MainOrdersUploadSummaryRequestIdRoute =
  MainOrdersUploadSummaryRequestIdRouteImport.update({
    id: '/orders/upload-summary/$requestId',
    path: '/orders/upload-summary/$requestId',
    getParentRoute: () => MainRoute,
  } as any)
const MainOrdersGenerateInvoiceOrderIdRoute =
  MainOrdersGenerateInvoiceOrderIdRouteImport.update({
    id: '/orders/generate-invoice/$orderId',
    path: '/orders/generate-invoice/$orderId',
    getParentRoute: () => MainRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof MainIndexRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/about': typeof MainAboutRoute
  '/upload-products': typeof MainUploadProductsRoute
  '/connect-account': typeof OnboardingConnectAccountRoute
  '/docs/privacy-policy': typeof DocsDocsPrivacyPolicyRoute
  '/docs/tos': typeof DocsDocsTosRoute
  '/orders/$orderId': typeof MainOrdersOrderIdRoute
  '/orders/upload': typeof MainOrdersUploadRoute
  '/whatsapp-monitoring/$groupId': typeof MainWhatsappMonitoringGroupIdRoute
  '/orders/': typeof MainOrdersIndexRoute
  '/products/': typeof MainProductsIndexRoute
  '/settings/': typeof MainSettingsIndexRoute
  '/whatsapp-monitoring/': typeof MainWhatsappMonitoringIndexRoute
  '/orders/generate-invoice/$orderId': typeof MainOrdersGenerateInvoiceOrderIdRoute
  '/orders/upload-summary/$requestId': typeof MainOrdersUploadSummaryRequestIdRoute
  '/products/allocation/upload': typeof MainProductsAllocationUploadRoute
  '/products/allocation/': typeof MainProductsAllocationIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof MainIndexRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/about': typeof MainAboutRoute
  '/upload-products': typeof MainUploadProductsRoute
  '/connect-account': typeof OnboardingConnectAccountRoute
  '/docs/privacy-policy': typeof DocsDocsPrivacyPolicyRoute
  '/docs/tos': typeof DocsDocsTosRoute
  '/orders/$orderId': typeof MainOrdersOrderIdRoute
  '/orders/upload': typeof MainOrdersUploadRoute
  '/whatsapp-monitoring/$groupId': typeof MainWhatsappMonitoringGroupIdRoute
  '/orders': typeof MainOrdersIndexRoute
  '/products': typeof MainProductsIndexRoute
  '/settings': typeof MainSettingsIndexRoute
  '/whatsapp-monitoring': typeof MainWhatsappMonitoringIndexRoute
  '/orders/generate-invoice/$orderId': typeof MainOrdersGenerateInvoiceOrderIdRoute
  '/orders/upload-summary/$requestId': typeof MainOrdersUploadSummaryRequestIdRoute
  '/products/allocation/upload': typeof MainProductsAllocationUploadRoute
  '/products/allocation': typeof MainProductsAllocationIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_docs': typeof DocsRouteWithChildren
  '/_main': typeof MainRouteWithChildren
  '/_onboarding': typeof OnboardingRouteWithChildren
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_main/about': typeof MainAboutRoute
  '/_main/upload-products': typeof MainUploadProductsRoute
  '/_onboarding/connect-account': typeof OnboardingConnectAccountRoute
  '/_main/': typeof MainIndexRoute
  '/_docs/docs/privacy-policy': typeof DocsDocsPrivacyPolicyRoute
  '/_docs/docs/tos': typeof DocsDocsTosRoute
  '/_main/orders/$orderId': typeof MainOrdersOrderIdRoute
  '/_main/orders/upload': typeof MainOrdersUploadRoute
  '/_main/whatsapp-monitoring/$groupId': typeof MainWhatsappMonitoringGroupIdRoute
  '/_main/orders/': typeof MainOrdersIndexRoute
  '/_main/products/': typeof MainProductsIndexRoute
  '/_main/settings/': typeof MainSettingsIndexRoute
  '/_main/whatsapp-monitoring/': typeof MainWhatsappMonitoringIndexRoute
  '/_main/orders/generate-invoice/$orderId': typeof MainOrdersGenerateInvoiceOrderIdRoute
  '/_main/orders/upload-summary/$requestId': typeof MainOrdersUploadSummaryRequestIdRoute
  '/_main/products/allocation/upload': typeof MainProductsAllocationUploadRoute
  '/_main/products/allocation/': typeof MainProductsAllocationIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/about'
    | '/upload-products'
    | '/connect-account'
    | '/docs/privacy-policy'
    | '/docs/tos'
    | '/orders/$orderId'
    | '/orders/upload'
    | '/whatsapp-monitoring/$groupId'
    | '/orders/'
    | '/products/'
    | '/settings/'
    | '/whatsapp-monitoring/'
    | '/orders/generate-invoice/$orderId'
    | '/orders/upload-summary/$requestId'
    | '/products/allocation/upload'
    | '/products/allocation/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/about'
    | '/upload-products'
    | '/connect-account'
    | '/docs/privacy-policy'
    | '/docs/tos'
    | '/orders/$orderId'
    | '/orders/upload'
    | '/whatsapp-monitoring/$groupId'
    | '/orders'
    | '/products'
    | '/settings'
    | '/whatsapp-monitoring'
    | '/orders/generate-invoice/$orderId'
    | '/orders/upload-summary/$requestId'
    | '/products/allocation/upload'
    | '/products/allocation'
  id:
    | '__root__'
    | '/_auth'
    | '/_docs'
    | '/_main'
    | '/_onboarding'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_main/about'
    | '/_main/upload-products'
    | '/_onboarding/connect-account'
    | '/_main/'
    | '/_docs/docs/privacy-policy'
    | '/_docs/docs/tos'
    | '/_main/orders/$orderId'
    | '/_main/orders/upload'
    | '/_main/whatsapp-monitoring/$groupId'
    | '/_main/orders/'
    | '/_main/products/'
    | '/_main/settings/'
    | '/_main/whatsapp-monitoring/'
    | '/_main/orders/generate-invoice/$orderId'
    | '/_main/orders/upload-summary/$requestId'
    | '/_main/products/allocation/upload'
    | '/_main/products/allocation/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  DocsRoute: typeof DocsRouteWithChildren
  MainRoute: typeof MainRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_onboarding': {
      id: '/_onboarding'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_docs': {
      id: '/_docs'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/': {
      id: '/_main/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MainIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_onboarding/connect-account': {
      id: '/_onboarding/connect-account'
      path: '/connect-account'
      fullPath: '/connect-account'
      preLoaderRoute: typeof OnboardingConnectAccountRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_main/upload-products': {
      id: '/_main/upload-products'
      path: '/upload-products'
      fullPath: '/upload-products'
      preLoaderRoute: typeof MainUploadProductsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/about': {
      id: '/_main/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof MainAboutRouteImport
      parentRoute: typeof MainRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_main/whatsapp-monitoring/': {
      id: '/_main/whatsapp-monitoring/'
      path: '/whatsapp-monitoring'
      fullPath: '/whatsapp-monitoring/'
      preLoaderRoute: typeof MainWhatsappMonitoringIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/settings/': {
      id: '/_main/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof MainSettingsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/products/': {
      id: '/_main/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof MainProductsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/': {
      id: '/_main/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof MainOrdersIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/whatsapp-monitoring/$groupId': {
      id: '/_main/whatsapp-monitoring/$groupId'
      path: '/whatsapp-monitoring/$groupId'
      fullPath: '/whatsapp-monitoring/$groupId'
      preLoaderRoute: typeof MainWhatsappMonitoringGroupIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/upload': {
      id: '/_main/orders/upload'
      path: '/orders/upload'
      fullPath: '/orders/upload'
      preLoaderRoute: typeof MainOrdersUploadRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/$orderId': {
      id: '/_main/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof MainOrdersOrderIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_docs/docs/tos': {
      id: '/_docs/docs/tos'
      path: '/docs/tos'
      fullPath: '/docs/tos'
      preLoaderRoute: typeof DocsDocsTosRouteImport
      parentRoute: typeof DocsRoute
    }
    '/_docs/docs/privacy-policy': {
      id: '/_docs/docs/privacy-policy'
      path: '/docs/privacy-policy'
      fullPath: '/docs/privacy-policy'
      preLoaderRoute: typeof DocsDocsPrivacyPolicyRouteImport
      parentRoute: typeof DocsRoute
    }
    '/_main/products/allocation/': {
      id: '/_main/products/allocation/'
      path: '/products/allocation'
      fullPath: '/products/allocation/'
      preLoaderRoute: typeof MainProductsAllocationIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/products/allocation/upload': {
      id: '/_main/products/allocation/upload'
      path: '/products/allocation/upload'
      fullPath: '/products/allocation/upload'
      preLoaderRoute: typeof MainProductsAllocationUploadRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/upload-summary/$requestId': {
      id: '/_main/orders/upload-summary/$requestId'
      path: '/orders/upload-summary/$requestId'
      fullPath: '/orders/upload-summary/$requestId'
      preLoaderRoute: typeof MainOrdersUploadSummaryRequestIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/orders/generate-invoice/$orderId': {
      id: '/_main/orders/generate-invoice/$orderId'
      path: '/orders/generate-invoice/$orderId'
      fullPath: '/orders/generate-invoice/$orderId'
      preLoaderRoute: typeof MainOrdersGenerateInvoiceOrderIdRouteImport
      parentRoute: typeof MainRoute
    }
  }
}

interface AuthRouteChildren {
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DocsRouteChildren {
  DocsDocsPrivacyPolicyRoute: typeof DocsDocsPrivacyPolicyRoute
  DocsDocsTosRoute: typeof DocsDocsTosRoute
}

const DocsRouteChildren: DocsRouteChildren = {
  DocsDocsPrivacyPolicyRoute: DocsDocsPrivacyPolicyRoute,
  DocsDocsTosRoute: DocsDocsTosRoute,
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)

interface MainRouteChildren {
  MainAboutRoute: typeof MainAboutRoute
  MainUploadProductsRoute: typeof MainUploadProductsRoute
  MainIndexRoute: typeof MainIndexRoute
  MainOrdersOrderIdRoute: typeof MainOrdersOrderIdRoute
  MainOrdersUploadRoute: typeof MainOrdersUploadRoute
  MainWhatsappMonitoringGroupIdRoute: typeof MainWhatsappMonitoringGroupIdRoute
  MainOrdersIndexRoute: typeof MainOrdersIndexRoute
  MainProductsIndexRoute: typeof MainProductsIndexRoute
  MainSettingsIndexRoute: typeof MainSettingsIndexRoute
  MainWhatsappMonitoringIndexRoute: typeof MainWhatsappMonitoringIndexRoute
  MainOrdersGenerateInvoiceOrderIdRoute: typeof MainOrdersGenerateInvoiceOrderIdRoute
  MainOrdersUploadSummaryRequestIdRoute: typeof MainOrdersUploadSummaryRequestIdRoute
  MainProductsAllocationUploadRoute: typeof MainProductsAllocationUploadRoute
  MainProductsAllocationIndexRoute: typeof MainProductsAllocationIndexRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainAboutRoute: MainAboutRoute,
  MainUploadProductsRoute: MainUploadProductsRoute,
  MainIndexRoute: MainIndexRoute,
  MainOrdersOrderIdRoute: MainOrdersOrderIdRoute,
  MainOrdersUploadRoute: MainOrdersUploadRoute,
  MainWhatsappMonitoringGroupIdRoute: MainWhatsappMonitoringGroupIdRoute,
  MainOrdersIndexRoute: MainOrdersIndexRoute,
  MainProductsIndexRoute: MainProductsIndexRoute,
  MainSettingsIndexRoute: MainSettingsIndexRoute,
  MainWhatsappMonitoringIndexRoute: MainWhatsappMonitoringIndexRoute,
  MainOrdersGenerateInvoiceOrderIdRoute: MainOrdersGenerateInvoiceOrderIdRoute,
  MainOrdersUploadSummaryRequestIdRoute: MainOrdersUploadSummaryRequestIdRoute,
  MainProductsAllocationUploadRoute: MainProductsAllocationUploadRoute,
  MainProductsAllocationIndexRoute: MainProductsAllocationIndexRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

interface OnboardingRouteChildren {
  OnboardingConnectAccountRoute: typeof OnboardingConnectAccountRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingConnectAccountRoute: OnboardingConnectAccountRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  DocsRoute: DocsRouteWithChildren,
  MainRoute: MainRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
